/* Product-page delivery estimate. Delivery is 3–5 calendar days after processing completes. */
(function (global) {
  'use strict';
  const format = (date) => date.toLocaleDateString('en-US', { month: 'short', day: 'numeric' }).toUpperCase();
  const addDays = (date, days) => new Date(date.getFullYear(), date.getMonth(), date.getDate() + days, 12);
  const range = (start, end) => {
    const first = format(start), last = format(end);
    if (start.getFullYear() === end.getFullYear() && first === last) return first;
    return start.getFullYear() === end.getFullYear() && start.getMonth() === end.getMonth()
      ? `${first} - ${end.getDate()}` : `${first} - ${last}`;
  };
  const labels = (today, processing = 1, minimum = 3, maximum = 5, processingDate = '') => {
    const parts = /^(\d{4})-(\d{2})-(\d{2})$/.exec(processingDate);
    const scheduled = parts ? new Date(Number(parts[1]), Number(parts[2]) - 1, Number(parts[3]), 12) : null;
    const pending = scheduled && scheduled >= addDays(today, 0);
    const processingEnd = pending ? scheduled : addDays(today, processing);
    return {
      purchased: format(today),
      processing: pending ? format(scheduled) : range(today, processingEnd),
      delivered: range(addDays(processingEnd, minimum), addDays(processingEnd, maximum))
    };
  };
  const untilMidnight = (now) => new Date(now.getFullYear(), now.getMonth(), now.getDate() + 1).getTime() - now.getTime() + 100;
  if (typeof module !== 'undefined' && module.exports) module.exports = { format, addDays, range, labels, untilMidnight };
  if (!global.document || global.IRDeliveryTimeline) return;

  const document = global.document;
  const selector = '[data-ir-delivery-timeline]';
  let midnightTimer;
  const observed = new WeakSet();
  const fit = (root) => {
    if (root.hidden) return;
    root.classList.remove('ir-dt--compact', 'ir-dt--stacked', 'ir-dt--vertical');
    const style = getComputedStyle(root);
    const available = root.clientWidth - parseFloat(style.paddingLeft) - parseFloat(style.paddingRight);
    const steps = [...root.querySelectorAll('.ir-dt__step')];
    const stepWidth = () => steps.reduce((total, step) => total + step.getBoundingClientRect().width, 0);
    const barMargins = [...root.querySelectorAll('.ir-dt__bar')].reduce((total, bar) => {
      const barStyle = getComputedStyle(bar);
      return total + parseFloat(barStyle.marginLeft) + parseFloat(barStyle.marginRight);
    }, 0);
    if (stepWidth() + barMargins > available) root.classList.add('ir-dt--compact');
    if (root.classList.contains('ir-dt--compact') && stepWidth() + 16 > available) root.classList.add('ir-dt--stacked');
    if (root.classList.contains('ir-dt--stacked') && stepWidth() + 16 > available) root.classList.add('ir-dt--vertical');
  };
  const observer = global.ResizeObserver ? new ResizeObserver((entries) => entries.forEach(({ target }) => fit(target))) : null;
  const render = (root, today = new Date()) => {
    const values = labels(today, Number(root.dataset.processingDays), Number(root.dataset.deliveryMinDays), Number(root.dataset.deliveryMaxDays), root.dataset.processingDate);
    Object.entries(values).forEach(([key, value]) => { root.querySelector(`[data-dt="${key}"]`).textContent = value; });
    fit(root);
  };
  const setState = (root, state) => {
    root.dataset.variantId = state.variantId;
    root.hidden = !state.available || Boolean(state.preorder);
    render(root);
  };
  const initialState = (root) => {
    const dataNode = document.getElementById('ir-dynamic-purchase-state-data');
    if (!dataNode) return;
    try {
      const data = JSON.parse(dataNode.textContent);
      const section = root.closest('[data-section-id]');
      const input = section && section.querySelector('form[action*="/cart/add"] [name="id"]');
      const variantId = String(input && input.value || data.selectedVariantId);
      const variant = data.variants[variantId];
      if (variant) setState(root, { variantId, available: variant.available, preorder: Boolean(variant.planId) });
    } catch (_error) { root.hidden = true; }
  };
  const refresh = () => document.querySelectorAll(selector).forEach((root) => render(root));
  const schedule = () => {
    global.clearTimeout(midnightTimer);
    midnightTimer = global.setTimeout(() => { refresh(); schedule(); }, untilMidnight(new Date()));
  };
  const init = () => {
    document.querySelectorAll(selector).forEach((root) => {
      initialState(root);
      if (observer && !observed.has(root)) { observer.observe(root); observed.add(root); }
    });
    schedule();
  };
  document.addEventListener('ir:purchase-state', (event) => {
    event.target.querySelectorAll(selector).forEach((root) => setState(root, event.detail));
  });
  document.addEventListener('visibilitychange', () => { if (!document.hidden) { refresh(); schedule(); } });
  document.addEventListener('shopify:section:load', init);
  global.addEventListener('pageshow', init);
  if (document.fonts) document.fonts.ready.then(refresh);
  global.IRDeliveryTimeline = { render, init };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init, { once: true });
  else init();
})(typeof window !== 'undefined' ? window : globalThis);
